import './brokerMiFID2DisclaimerForAltFunds.scss';

import React, {useEffect} from "react";
import moment from 'moment';
import PropTypes from "prop-types";
const { formatText, FormattedText } = require('core/i18n').i18n;

import { buildFormattedDate } from 'utilities/dateHelper';
import  { conditionalValueOrHyphen } from 'utilities/valueHelper';


import { OKSectionBox } from 'commonsComponents/OKSectionBox';
import { OKButton } from 'components/commons/OKButton/OKButton';
import BrokerMiFID2DisclaimerForAltFundsDisclaimerItem from './brokerMiFID2DisclaimerForAltFundsDisclaimerItem/brokerMiFID2DisclaimerForAltFundsDisclaimerItem';

import { DATE_FORMAT_SLASHED_ES, DATE_FORMAT_COMPLETE } from 'constants/index'

const BrokerMiFID2DisclaimerForAltFunds = ({
    immBrokerConvenienceMiFIDTest,
    onContinueOperation,
    onCancel,
    addPrivateEquityDisclaimers,
    isIntermediateScreen,
}) => {
    const lastExecutionDate = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'lastExecutionDate']);
    const executionDate = moment(lastExecutionDate, DATE_FORMAT_SLASHED_ES);
    const executionDateFormatted = conditionalValueOrHyphen(
        executionDate.isValid(),
        buildFormattedDate(executionDate, DATE_FORMAT_COMPLETE)
    );
    const scoreText = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'convenienceEvaluationDisclaimer']) 
        ? immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'convenienceEvaluationDisclaimer'])
        : immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoreText']);
    
    useEffect(() => {
        addPrivateEquityDisclaimers();
        if (!isIntermediateScreen) {
            const customData = {
                event_name: "step_mifid",
                pageName: "/buyAlternativeFunds/step0/mifid",
                sectionFamily: "wealth",
                sectionCategory: "products",
                sectionName: "funds",
                serviceType: "productContracting",
                interactionType: "funnel",
                processType: "buyAlternativeFunds",
                processStep: "step0",
                processDetail: "mifid",
                productName: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isinId'])
            };
            window &&
            window.utag &&
            window.utag.view &&
            window.utag.view(customData);
        }
    }, []);
    const mifidDisclaimers = (
        <div className="broker-mifid2-disclaimer-alt-funds__section">
            <div className="broker-mifid2-disclaimer-alt-funds__section-title-container">
                <h2 className="broker-mifid2-disclaimer-alt-funds__section-title">
                    <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_mifidWarnings_title" />
                </h2>
            </div>
            <BrokerMiFID2DisclaimerForAltFundsDisclaimerItem
                title={formatText('broker-convenienceMifidAltFundsDisclaimer_mifidWarnings_publicObjetiveTitle')}
                icon={<i className="broker-mifid2-disclaimer-alt-funds__icon broker-mifid2-disclaimer-alt-funds__icon-public-objetive" />}
            >
                <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_mifidWarnings_publicObjetiveContent" />
            </BrokerMiFID2DisclaimerForAltFundsDisclaimerItem>
            <BrokerMiFID2DisclaimerForAltFundsDisclaimerItem
                title={formatText('broker-convenienceMifidAltFundsDisclaimer_mifidWarnings_concentrationTitle')}
                icon={<i className="broker-mifid2-disclaimer-alt-funds__icon broker-mifid2-disclaimer-alt-funds__icon-concentration" />}
            >
                <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_mifidWarnings_concentrationContent" />
            </BrokerMiFID2DisclaimerForAltFundsDisclaimerItem>
        </div>
    )

    const alternativeFundsRisksDisclaimers = (
        <div className="broker-mifid2-disclaimer-alt-funds__section">
            <div className="broker-mifid2-disclaimer-alt-funds__section-title-container">
                <h2 className="broker-mifid2-disclaimer-alt-funds__section-title">
                    <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_altFundsRisks_title" />
                </h2>
            </div>
            <BrokerMiFID2DisclaimerForAltFundsDisclaimerItem
                title={formatText('broker-convenienceMifidAltFundsDisclaimer_altFundsRisks_investmentTitle')}
                icon={<i className="broker-mifid2-disclaimer-alt-funds__icon broker-mifid2-disclaimer-alt-funds__icon-profitability" />}
            >
                <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_altFundsRisks_investmentContent" />
            </BrokerMiFID2DisclaimerForAltFundsDisclaimerItem>
            <BrokerMiFID2DisclaimerForAltFundsDisclaimerItem
                title={formatText('broker-convenienceMifidAltFundsDisclaimer_altFundsRisks_liquidityTitle')}
                icon={<i className="broker-mifid2-disclaimer-alt-funds__icon broker-mifid2-disclaimer-alt-funds__icon-liquidity-risk" />}
            >
                <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_altFundsRisks_liquidityContent" />
            </BrokerMiFID2DisclaimerForAltFundsDisclaimerItem>
            <BrokerMiFID2DisclaimerForAltFundsDisclaimerItem
                title={formatText('broker-convenienceMifidAltFundsDisclaimer_altFundsRisks_appeceamentTitle')}
                icon={<i className="broker-mifid2-disclaimer-alt-funds__icon broker-mifid2-disclaimer-alt-funds__icon-calendar" />}
            >
                <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_altFundsRisks_appeceamentContent" />
            </BrokerMiFID2DisclaimerForAltFundsDisclaimerItem>
            <BrokerMiFID2DisclaimerForAltFundsDisclaimerItem
                title={formatText('broker-convenienceMifidAltFundsDisclaimer_altFundsRisks_opportunitiesTitle')}
                icon={<i className="broker-mifid2-disclaimer-alt-funds__icon broker-mifid2-disclaimer-alt-funds__icon-coins" />}
            >
                <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_altFundsRisks_opportunitiesContent" />
            </BrokerMiFID2DisclaimerForAltFundsDisclaimerItem>
            <BrokerMiFID2DisclaimerForAltFundsDisclaimerItem
                title={formatText('broker-convenienceMifidAltFundsDisclaimer_altFundsRisks_otherRisksTitle')}
                icon={<i className="broker-mifid2-disclaimer-alt-funds__icon broker-mifid2-disclaimer-alt-funds__icon-gears" />}
            >
                <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_altFundsRisks_otherRisksContent" />
            </BrokerMiFID2DisclaimerForAltFundsDisclaimerItem>
        </div>
    );
    return (
        <div className="broker-mifid2-disclaimer-alt-funds">
            <OKSectionBox>
                <div className="broker-mifid2-disclaimer-alt-funds__title-container">
                    <h2 className="broker-mifid2-disclaimer-alt-funds__title">
                        <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_title" /> 
                    </h2>
                </div>
                <div className="broker-mifid2-disclaimer-alt-funds__separator" />
                <p className="broker-mifid2-disclaimer-alt-funds__test-score-title">
                    <FormattedText value="brokerMiFIDDisclaimerView-testScoreTitle" />
                </p>
                <p className="broker-mifid2-disclaimer-alt-funds__test-score-description">
                    {scoreText}
                </p>
                <p className="broker-mifid2-disclaimer-añt-funds__test-execution-datetime">
                    <FormattedText
                        value="brokerMiFIDDisclaimerView-dateAndTimeOfCompletion"
                        injectedStrings={[executionDateFormatted]}
                    />
                </p>
                <div className="broker-mifid2-disclaimer-alt-funds__separator" />
                {mifidDisclaimers}
                <div className="broker-mifid2-disclaimer-alt-funds__separator" />
                {alternativeFundsRisksDisclaimers}
                <div className="broker-mifid2-disclaimer-alt-funds__separator" />
                <div className="broker-mifid2-disclaimer-alt-funds__footer">
                    <div className="row">
                        <div className="col-xs-6">
                            <OKButton modifier="link-ghost" onClick={onCancel}>
                                <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_cancelButton" />
                            </OKButton>
                        </div>
                        <div className="col-xs-6 text-right">
                            <OKButton onClick={onContinueOperation}>
                                <FormattedText value="broker-convenienceMifidAltFundsDisclaimer_continueButton" />
                            </OKButton>
                        </div>
                    </div>
                </div>
            </OKSectionBox>
        </div>
    );
};

BrokerMiFID2DisclaimerForAltFunds.propTypes = {
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    onContinueOperation: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    addPrivateEquityDisclaimers: PropTypes.func.isRequired,
    isIntermediateScreen: PropTypes.bool,
}

BrokerMiFID2DisclaimerForAltFunds.defaultProps = {
    isIntermediateScreen: false
};

export default BrokerMiFID2DisclaimerForAltFunds;